const CarouselTypeMixins = {
    methods: {
        photoSlidesshow(index) {
            this.$modulesEventBus.$emit(`photo-slidesshow${this.id}`, index);
        },
    },
};
export default CarouselTypeMixins;
